<template>
  <div>
    <MastHeadSectionComponent />
    <ProductsSectionComponent />
    <AboutSectionComponent />
    <ContactSectionComponent />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MastHeadSectionComponent from "@/components/home/MastHeadSectionComponent.vue";
import ProductsSectionComponent from "@/components/home/ProductsSectionComponent.vue";
import AboutSectionComponent from "@/components/home/AboutSectionComponent.vue";
import ContactSectionComponent from "@/components/general/ContactSectionComponent.vue";

export default defineComponent({
  name: "HomeView",
  components: {
    MastHeadSectionComponent,
    ProductsSectionComponent,
    AboutSectionComponent,
    ContactSectionComponent,
  },
});
</script>

<style src="@/assets/css/style.css"></style>
